import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row gy-5 g-xl-8 mb-6" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "card-body p-10 p-lg-15" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "mb-17" }, [
        /*#__PURE__*/_createElementVNode("h3", { class: "text-black mb-7" }, "Latest Articles, News & Updates"),
        /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-9" }),
        /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "h-100 d-flex flex-column justify-content-between pe-lg-6 mb-lg-0 mb-10" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
                /*#__PURE__*/_createElementVNode("iframe", {
                  class: "embed-responsive-item card-rounded h-275px w-100",
                  src: "https://www.youtube.com/embed/qIHXpnASPAA",
                  allowfullscreen: "allowfullscreen"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
                /*#__PURE__*/_createElementVNode("a", {
                  class: "fs-2 text-dark fw-bolder text-hover-primary text-dark lh-base",
                  href: "#"
                }, [
                  /*#__PURE__*/_createTextVNode("Metronic Admin - How To Get Started Tutorial. "),
                  /*#__PURE__*/_createElementVNode("br"),
                  /*#__PURE__*/_createTextVNode("Create easy customizable applications")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-5 text-gray-600 text-dark mt-4" }, "We’ve been focused on making the from v4 to v5 but we have also not been afraid to step away been focused on from v4 to v5 speaker approachable making focused a but from a step away afraid to step away been focused Writing a blog post is a little like driving; you can study the highway code (or read articles telling you how to write a blog post) for months, but nothing can prepare you for the real thing like getting behind the wheel")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center pe-2" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-35px symbol-circle me-3" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      alt: "",
                      src: "/media/avatars/150-8.jpg"
                    })
                  ]),
                  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bolder" }, [
                    /*#__PURE__*/_createElementVNode("a", {
                      class: "text-gray-700 text-hover-primary",
                      href: "/metronic8/demo1/../demo1/pages/profile/overview.html"
                    }, "David Morgan"),
                    /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "on Apr 27 2021")
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-primary fw-bolder my-2" }, "TUTORIALS")
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 justify-content-between d-flex flex-column" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "ps-lg-6 mb-16 mt-md-0 mt-17" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
                /*#__PURE__*/_createElementVNode("a", {
                  class: "fw-bolder text-dark mb-4 fs-2 lh-base text-hover-primary",
                  href: "#"
                }, "Metronic Admin - How To Get Started Tutorial. Create customizable applications"),
                /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-5 mt-4 text-gray-600 text-dark" }, "We’ve been focused on making the from v4 to v5 a but we’ve also not been afraid to step away been focused on from v4 to v5 speaker approachable making focused")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center pe-2" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-35px symbol-circle me-3" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "/media/avatars/150-5.jpg",
                      alt: ""
                    })
                  ]),
                  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bolder" }, [
                    /*#__PURE__*/_createElementVNode("a", {
                      class: "text-gray-700 text-hover-primary",
                      href: "/metronic8/demo1/../demo1/pages/profile/overview.html"
                    }, "Jane Miller"),
                    /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "on Apr 27 2021")
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-info fw-bolder my-2" }, "BLOG")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "ps-lg-6 mb-16" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
                /*#__PURE__*/_createElementVNode("a", {
                  class: "fw-bolder text-dark mb-4 fs-2 lh-base text-hover-primary",
                  href: "#"
                }, "Metronic Admin - How To Get Started Tutorial."),
                /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-5 mt-4 text-gray-600 text-dark" }, "We’ve been focused on making the from v4 to v5 a but we’ve also not been afraid to step away")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center pe-2" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-35px symbol-circle me-3" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "/media/avatars/150-8.jpg",
                      alt: ""
                    })
                  ]),
                  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bolder" }, [
                    /*#__PURE__*/_createElementVNode("a", {
                      class: "text-gray-700 text-hover-primary",
                      href: "/metronic8/demo1/../demo1/pages/profile/overview.html"
                    }, "Cris Morgan"),
                    /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "on Mar 14 2021")
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-primary fw-bolder my-2" }, "TUTORIALS")
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "ps-lg-6" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "mb-6" }, [
                /*#__PURE__*/_createElementVNode("a", {
                  class: "fw-bolder text-dark mb-4 fs-2 lh-base text-hover-primary",
                  href: "#"
                }, "Metronic Admin - How To Get Started Tutorial. Create best applications"),
                /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-5 mt-4 text-gray-600 text-dark" }, "We’ve been focused on making the from v4 to v5 but we’ve also not been afraid to step away been focused")
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack flex-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center pe-2" }, [
                  /*#__PURE__*/_createElementVNode("div", { class: "symbol symbol-35px symbol-circle me-3" }, [
                    /*#__PURE__*/_createElementVNode("img", {
                      src: "/media/avatars/150-24.jpg",
                      alt: ""
                    })
                  ]),
                  /*#__PURE__*/_createElementVNode("div", { class: "fs-5 fw-bolder" }, [
                    /*#__PURE__*/_createElementVNode("a", {
                      class: "text-gray-700 text-hover-primary",
                      href: "/metronic8/demo1/../demo1/pages/profile/overview.html"
                    }, "Cris Morgan"),
                    /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "on Mar 14 2021")
                  ])
                ]),
                /*#__PURE__*/_createElementVNode("span", { class: "badge badge-light-warning fw-bolder my-2" }, "NEWS")
              ])
            ])
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "mb-17" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-5" }, [
          /*#__PURE__*/_createElementVNode("h3", { class: "text-black" }, "Video Tutorials"),
          /*#__PURE__*/_createElementVNode("a", {
            class: "fs-6 fw-bold link-primary",
            href: "#"
          }, "View All Videos")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-9" }),
        /*#__PURE__*/_createElementVNode("div", { class: "row g-10" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "card-xl-stretch me-md-6" }, [
              /*#__PURE__*/_createElementVNode("a", {
                class: "d-block bgi-no-repeat bgi-size-cover bgi-position-center card-rounded position-relative min-h-175px mb-5",
                style: {"background-image":"url('/media/stock/600x400/img-73.jpg')"},
                "data-fslightbox": "lightbox-video-tutorials",
                href: "https://www.youtube.com/embed/ptgwzvvAHy4"
              }, [
                /*#__PURE__*/_createElementVNode("img", {
                  class: "position-absolute top-50 start-50 translate-middle",
                  src: "/media/svg/misc/video-play.svg",
                  alt: ""
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "m-0" }, [
                /*#__PURE__*/_createElementVNode("a", {
                  class: "fs-4 text-dark fw-bolder text-hover-primary text-dark lh-base",
                  href: "/metronic8/demo1/../demo1/pages/profile/overview.html"
                }, "Metronic Admin - How To Started the Dashboard Tutorial"),
                /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-5 text-gray-600 text-dark my-4" }, "We’ve been focused on making a the from also not been afraid to and step away been focused create eye"),
                /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bolder" }, [
                  /*#__PURE__*/_createElementVNode("a", {
                    class: "text-gray-700 text-hover-primary",
                    href: "/metronic8/demo1/../demo1/pages/profile/overview.html"
                  }, "Jane Miller"),
                  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "on Mar 21 2021")
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "card-xl-stretch mx-md-3" }, [
              /*#__PURE__*/_createElementVNode("a", {
                class: "d-block bgi-no-repeat bgi-size-cover bgi-position-center card-rounded position-relative min-h-175px mb-5",
                style: {"background-image":"url('/media/stock/600x400/img-74.jpg')"},
                "data-fslightbox": "lightbox-video-tutorials",
                href: "https://www.youtube.com/embed/UPNvy-2ZtQM"
              }, [
                /*#__PURE__*/_createElementVNode("img", {
                  class: "position-absolute top-50 start-50 translate-middle",
                  src: "/media/svg/misc/video-play.svg",
                  alt: ""
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "m-0" }, [
                /*#__PURE__*/_createElementVNode("a", {
                  class: "fs-4 text-dark fw-bolder text-hover-primary text-dark lh-base",
                  href: "/metronic8/demo1/../demo1/pages/profile/overview.html"
                }, "Metronic Admin - How To Started the Dashboard Tutorial"),
                /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-5 text-gray-600 text-dark my-4" }, "We’ve been focused on making the from v4 to v5 but we have also not been afraid to step away been focused"),
                /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bolder" }, [
                  /*#__PURE__*/_createElementVNode("a", {
                    class: "text-gray-700 text-hover-primary",
                    href: "/metronic8/demo1/../demo1/pages/profile/overview.html"
                  }, "Cris Morgan"),
                  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "on Apr 14 2021")
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "card-xl-stretch ms-md-6" }, [
              /*#__PURE__*/_createElementVNode("a", {
                class: "d-block bgi-no-repeat bgi-size-cover bgi-position-center card-rounded position-relative min-h-175px mb-5",
                style: {"background-image":"url('/media/stock/600x400/img-47.jpg')"},
                "data-fslightbox": "lightbox-video-tutorials",
                href: "https://www.youtube.com/embed/gq3eQKc71kc"
              }, [
                /*#__PURE__*/_createElementVNode("img", {
                  class: "position-absolute top-50 start-50 translate-middle",
                  src: "/media/svg/misc/video-play.svg",
                  alt: ""
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "m-0" }, [
                /*#__PURE__*/_createElementVNode("a", {
                  class: "fs-4 text-dark fw-bolder text-hover-primary text-dark lh-base",
                  href: "/metronic8/demo1/../demo1/pages/profile/overview.html"
                }, "Metronic Admin - How To Started the Dashboard Tutorial"),
                /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-5 text-gray-600 text-dark my-4" }, "We’ve been focused on making the from v4 to v5 but we’ve also not been afraid to step away been focused"),
                /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bolder" }, [
                  /*#__PURE__*/_createElementVNode("a", {
                    class: "text-gray-700 text-hover-primary",
                    href: "/metronic8/demo1/../demo1/pages/profile/overview.html"
                  }, "Carles Nilson"),
                  /*#__PURE__*/_createElementVNode("span", { class: "text-muted" }, "on May 14 2021")
                ])
              ])
            ])
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "mb-17" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-5" }, [
          /*#__PURE__*/_createElementVNode("h3", { class: "text-black" }, "Hottest Bundles"),
          /*#__PURE__*/_createElementVNode("a", {
            class: "fs-6 fw-bold link-primary",
            href: "#"
          }, "View All Offers")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed mb-9" }),
        /*#__PURE__*/_createElementVNode("div", { class: "row g-10" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "card-xl-stretch me-md-6" }, [
              /*#__PURE__*/_createElementVNode("a", {
                class: "d-block overlay",
                "data-fslightbox": "lightbox-hot-sales",
                href: "/media/stock/600x400/img-23.jpg"
              }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-175px",
                  style: {"background-image":"url('/media/stock/600x400/img-23.jpg')"}
                }),
                /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer card-rounded bg-dark bg-opacity-25" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill fs-2x text-white" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, [
                /*#__PURE__*/_createElementVNode("a", {
                  class: "fs-4 text-dark fw-bolder text-hover-primary text-dark lh-base",
                  href: "#"
                }, "25 Products Mega Bundle with 50% off discount amazing"),
                /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-5 text-gray-600 text-dark mt-3" }, "We’ve been focused on making a the from also not been eye"),
                /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bolder mt-5 d-flex flex-stack" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "badge border-dashed fs-2 fw-bolder text-dark p-2" }, [
                    /*#__PURE__*/_createElementVNode("span", { class: "fs-6 fw-bold text-gray-400" }, "$"),
                    /*#__PURE__*/_createTextVNode("28")
                  ]),
                  /*#__PURE__*/_createElementVNode("a", {
                    class: "btn btn-primary",
                    href: "#"
                  }, "Purchase")
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "card-xl-stretch mx-md-3" }, [
              /*#__PURE__*/_createElementVNode("a", {
                class: "d-block overlay",
                "data-fslightbox": "lightbox-hot-sales",
                href: "/media/stock/600x600/img-14.jpg"
              }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-175px",
                  style: {"background-image":"url('/media/stock/600x600/img-14.jpg')"}
                }),
                /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer card-rounded bg-dark bg-opacity-25" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill fs-2x text-white" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, [
                /*#__PURE__*/_createElementVNode("a", {
                  class: "fs-4 text-dark fw-bolder text-hover-primary text-dark lh-base",
                  href: "#"
                }, "25 Products Mega Bundle with 50% off discount amazing"),
                /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-5 text-gray-600 text-dark mt-3" }, "We’ve been focused on making a the from also not been eye"),
                /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bolder mt-5 d-flex flex-stack" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "badge border-dashed fs-2 fw-bolder text-dark p-2" }, [
                    /*#__PURE__*/_createElementVNode("span", { class: "fs-6 fw-bold text-gray-400" }, "$"),
                    /*#__PURE__*/_createTextVNode("27")
                  ]),
                  /*#__PURE__*/_createElementVNode("a", {
                    class: "btn btn-primary",
                    href: "#"
                  }, "Purchase")
                ])
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col-md-4" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "card-xl-stretch ms-md-6" }, [
              /*#__PURE__*/_createElementVNode("a", {
                class: "d-block overlay",
                "data-fslightbox": "lightbox-hot-sales",
                href: "/media/stock/600x400/img-71.jpg"
              }, [
                /*#__PURE__*/_createElementVNode("div", {
                  class: "overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-175px",
                  style: {"background-image":"url('/media/stock/600x400/img-71.jpg')"}
                }),
                /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer card-rounded bg-dark bg-opacity-25" }, [
                  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill fs-2x text-white" })
                ])
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, [
                /*#__PURE__*/_createElementVNode("a", {
                  class: "fs-4 text-dark fw-bolder text-hover-primary text-dark lh-base",
                  href: "#"
                }, "25 Products Mega Bundle with 50% off discount amazing"),
                /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-5 text-gray-600 text-dark mt-3" }, "We’ve been focused on making a the from also not been eye"),
                /*#__PURE__*/_createElementVNode("div", { class: "fs-6 fw-bolder mt-5 d-flex flex-stack" }, [
                  /*#__PURE__*/_createElementVNode("span", { class: "badge border-dashed fs-2 fw-bolder text-dark p-2" }, [
                    /*#__PURE__*/_createElementVNode("span", { class: "fs-6 fw-bold text-gray-400" }, "$"),
                    /*#__PURE__*/_createTextVNode("25")
                  ]),
                  /*#__PURE__*/_createElementVNode("a", {
                    class: "btn btn-primary",
                    href: "#"
                  }, "Purchase")
                ])
              ])
            ])
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", null, [
        /*#__PURE__*/_createElementVNode("div", { class: "m-0" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack" }, [
            /*#__PURE__*/_createElementVNode("h3", { class: "text-black" }, "Latest Instagram Posts"),
            /*#__PURE__*/_createElementVNode("a", {
              class: "fs-6 fw-bold link-primary",
              href: "#"
            }, "View Instagram")
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed border-gray-300 mb-9 mt-5" })
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "row g-10 row-cols-2 row-cols-lg-5" }, [
          /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
            /*#__PURE__*/_createElementVNode("a", {
              class: "d-block overlay",
              "data-fslightbox": "lightbox-hot-sales",
              href: "/media/demos/demo9.png"
            }, [
              /*#__PURE__*/_createElementVNode("div", {
                class: "overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-175px",
                style: {"background-image":"url('/media/demos/demo9.png')"}
              }),
              /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer card-rounded bg-dark bg-opacity-25" }, [
                /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill fs-2x text-white" })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
            /*#__PURE__*/_createElementVNode("a", {
              class: "d-block overlay",
              "data-fslightbox": "lightbox-hot-sales",
              href: "/media/stock/900x600/32.jpg"
            }, [
              /*#__PURE__*/_createElementVNode("div", {
                class: "overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-175px",
                style: {"background-image":"url('/media/stock/900x600/32.jpg')"}
              }),
              /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer card-rounded bg-dark bg-opacity-25" }, [
                /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill fs-2x text-white" })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
            /*#__PURE__*/_createElementVNode("a", {
              class: "d-block overlay",
              "data-fslightbox": "lightbox-hot-sales",
              href: "/media/demos/demo4.png"
            }, [
              /*#__PURE__*/_createElementVNode("div", {
                class: "overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-175px",
                style: {"background-image":"url('/media/demos/demo4.png')"}
              }),
              /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer card-rounded bg-dark bg-opacity-25" }, [
                /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill fs-2x text-white" })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
            /*#__PURE__*/_createElementVNode("a", {
              class: "d-block overlay",
              "data-fslightbox": "lightbox-hot-sales",
              href: "/media/stock/600x600/img-13.jpg"
            }, [
              /*#__PURE__*/_createElementVNode("div", {
                class: "overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-175px",
                style: {"background-image":"url('/media/stock/600x600/img-13.jpg')"}
              }),
              /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer card-rounded bg-dark bg-opacity-25" }, [
                /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill fs-2x text-white" })
              ])
            ])
          ]),
          /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
            /*#__PURE__*/_createElementVNode("a", {
              class: "d-block overlay",
              "data-fslightbox": "lightbox-hot-sales",
              href: "/media/stock/600x400/img-52.jpg"
            }, [
              /*#__PURE__*/_createElementVNode("div", {
                class: "overlay-wrapper bgi-no-repeat bgi-position-center bgi-size-cover card-rounded min-h-175px",
                style: {"background-image":"url('/media/stock/600x400/img-52.jpg')"}
              }),
              /*#__PURE__*/_createElementVNode("div", { class: "overlay-layer card-rounded bg-dark bg-opacity-25" }, [
                /*#__PURE__*/_createElementVNode("i", { class: "bi bi-eye-fill fs-2x text-white" })
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}